import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import debounce from 'lodash.debounce'
import * as userSelectors from 'services/user/selectors'
import * as locationSelectors from 'services/location/selectors'
import { getLocationSuggestions, searchForCity } from 'services/location/actions'
import SingleSelectField from 'components/forms/SingleSelectField'

const mapStateToProps = (state) => ({
  displayLocation: userSelectors.selectDisplayLocation(state),
  locationSuggestions: locationSelectors.selectLocationSuggestions(state),
  citySuggestions: locationSelectors.selectCitySuggestions(state),
})

const mapDispatchToActions = {
  getLocationSuggestions, // Search City based on Google API
  searchForCity, // Search City based on Panama API
}

export class SearchCityState extends Component {

  static propTypes = {
    locationSuggestions: PropTypes.array,
    citySuggestions: PropTypes.array,
    getLocationSuggestions: PropTypes.func,
    searchForCity: PropTypes.func,
    displayLocation: PropTypes.string,
    fromPanama: PropTypes.bool,
  }

  componentDidMount () {
    const { displayLocation } = this.props
    this.props.getLocationSuggestions(displayLocation, true)
  }

  handleLocationSearch = debounce((value) => {
    if (value) {
      const { fromPanama } = this.props
      fromPanama ? this.props.searchForCity(value) : this.props.getLocationSuggestions(value)
    }
  }, 300)

  render () {
    const { fromPanama, citySuggestions, locationSuggestions } = this.props
    return (
      <SingleSelectField
        {...this.props}
        onInputChange={this.handleLocationSearch}
        options={fromPanama ? citySuggestions : locationSuggestions} />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(SearchCityState)
